import { BsPersonVcardFill } from "react-icons/bs";
import EmailUtils from "../../../../../shared/utils/EmailUtils";
import PhoneUtils from "../../../../../shared/utils/PhoneUtils";

export const dataSubmissionFormConfig = () => {
	return [
		{
			section: "Dados de Envio",
			icon: BsPersonVcardFill,
			fields: [
				{
					name: "completeName",
					label: "Nome completo *",
					type: "text",
					placeholder: "Insira o nome completo",
					defaultValue: "",
					columns: 6
				},
				{
					name: "emails",
					label: "E-mails *",
					type: "multi-input",
					defaultValue: [],
					placeholder: "exemplo@email.com",
					columns: 6,
					validateItem: EmailUtils.isValidEmail
				},
				{
					name: "telephone",
					label: "Telefone (Opcional)",
					type: "text",
					defaultValue: "",
					placeholder: "(00)0000-0000",
					mask: PhoneUtils.getTelephoneMask(),
					columns: 6
				},
				{
					name: "celphone",
					label: "Celular *",
					type: "text",
					defaultValue: "",
					placeholder: "(00)00000-0000",
					mask: PhoneUtils.getCellphoneMask(),
					columns: 6
				}
			]
		}
	];
};